import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const yuyan = ref(false);
    // 获取tabsList数据
    let tabsList = ref([]);
    // 解决项目刷新数据丢失的问题
    onMounted(() => {
      beforeRefresh();
      setActiveTabs();
      // 把当前路由添加到选项卡
      addTab();
      qiehuanZhEn(localStorage.getItem('lang') || 'zh');
    });
    tabsList = computed(() => {
      return store.getters.tabsList;
    });
    // console.log(tabsList)
    // 激活标签
    const activeTab = ref('');
    const setActiveTabs = () => {
      // console.log('激活:' + route.path)
      activeTab.value = route.path;
    };
    // 添加选项卡
    const addTab = () => {
      console.log();
      // 从当前路由获取path 和title
      // console.log(route)
      const {
        path,
        meta
      } = route;
      console.log('path:' + path);
      console.log('meta:' + meta);
      if (path === '/login') return;
      if (path === '/oauth') return;
      // 通过vuex 设置
      const tab = {
        path: path,
        title: meta.title,
        enTitle: meta.enTitle
      };
      store.commit('login/setTabsList', tab);
    };
    const clickTabs = tab => {
      const {
        props
      } = tab;
      sessionStorage.setItem('path', `${props.name}`);
      router.push({
        path: props.name
      });
    };
    watch(() => route.path, () => {
      setActiveTabs();
      // 把当前路由添加到选项卡
      addTab();
    });
    // 防止刷新数据丢失
    const beforeRefresh = () => {
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('tabsView', JSON.stringify(tabsList.value));
      });
      const tabSesion = sessionStorage.getItem('tabsView');
      if (tabSesion) {
        const oldTabs = JSON.parse(tabSesion);
        if (oldTabs.length > 0) {
          store.commit('login/setRemoveTab', oldTabs);
        }
      }
    };
    const removeTab = targetName => {
      if (targetName === '/home') return;
      const tabs = tabsList.value;
      let activeName = activeTab.value;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.path === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.path;
            }
          }
        });
      }
      activeTab.value = activeName; // 重新设置激活路由
      store.commit('login/setRemoveTab', tabs.filter(tab => tab.path !== targetName)); // 重新设置路由标签
      router.push({
        path: activeName
      }); // 路由跳转
    };
    // 监听中英文切换
    watch(() => store.getters.lang, () => {
      qiehuanZhEn(store.getters.lang);
    });
    function qiehuanZhEn(val) {
      if (val === 'en') {
        yuyan.value = true;
      } else {
        yuyan.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createBlock(_component_el_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        type: "card",
        class: "demo-tabs",
        closable: "",
        onTabRemove: removeTab,
        onTabClick: clickTabs
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabsList), item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.path,
            name: item.path,
            index: item.id
          }, {
            label: _withCtx(() => [yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.enTitle), 1)) : _createCommentVNode("", true), !yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.title), 1)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["name", "index"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});